// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CardAccountInfo_checkbox__1q0C3"};